import { TableHeader } from '@vizit/atoms';
import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from '@vizit/feature-flags';
import * as React from 'react';

interface ProductListingTableTheadProps {
  /**
   * Whether to show the action column
   * @default false
   */
  showActionColumn?: boolean;
}

const ProductListingTableThead = React.memo((props: ProductListingTableTheadProps) => {
  const { showActionColumn = false } = props;
  const isRetailerEnabled = useFeatureFlag(FEATURE_FLAGS.RETAILER, false);

  return (
    <TableHeader>
      <TableHeader.Column isRowHeader className="w-3/5">
        Product Page
      </TableHeader.Column>
      {isRetailerEnabled && (
        <TableHeader.Column className="whitespace-nowrap w-60 text-center">Retailer</TableHeader.Column>
      )}
      <TableHeader.Column className="whitespace-nowrap w-60 text-center">Live score</TableHeader.Column>
      <TableHeader.Column className="whitespace-nowrap w-60 text-center">Your score</TableHeader.Column>
      <TableHeader.Column className="whitespace-nowrap">Change</TableHeader.Column>
      {showActionColumn && <TableHeader.Column className="w-16" />}
    </TableHeader>
  );
});

export { ProductListingTableThead };
export type { ProductListingTableTheadProps };
